import { createElement } from 'react';
import type { GateSlots } from '@fsd/entities/dashboard-widget';
import { GateMovementsSlot, GateOperationSlot } from './gate-slot-modals';

/**
 * Los modales de `features/gate-movements` para los widgets de compuerta del tablero. `app` los
 * compone porque `entities/dashboard-widget` no puede importar una feature (wiki `frontend-fsd.md`).
 * En un `.ts`, como los kinds, para no romper el fast refresh.
 */
export const GATE_SLOTS: Required<GateSlots> = {
  gateOperation: ({ trigger, movementId, autoOpen }) =>
    createElement(GateOperationSlot, { trigger, movementId, autoOpen }),
  gateMovements: ({ trigger, gateId }) => createElement(GateMovementsSlot, { trigger, gateId }),
};
